import { observable, decorate } from 'mobx';
import api from '../api';
import logger from '../logger';
import { RESCORE_TOKEN } from '../constants/env';

export default class EntityStore {
  constructor(context) {
    this.context = context;
  }

  entity = null;

  errors = null;

  isBusy = false;

  fetchEntity = async (numbers, withAddress) => {
    this.isBusy = true;
    this.entity = null;
    this.errors = null;
    try {
      const [entity, address] = await Promise.all([
        api.entity.getEntityById(RESCORE_TOKEN, numbers),
        withAddress ? api.entity.getEntityAddress(RESCORE_TOKEN, numbers) : Promise.resolve(null),
      ]);
      if (entity !== null) {
        this.errors = [];
        this.entity = { ...address, ...entity };
      } else {
        this.errors = ['ошибка'];
        this.entity = null;
      }
    } catch (ex) {
      logger.error(ex);
    } finally {
      this.isBusy = false;
    }
    return this.entity;
  };
}

decorate(EntityStore, {
  entity: observable,
  errors: observable,
  isBusy: observable,
});
